import actions from "./actions";
import dayjs from "dayjs";
const initState = {
  destinationFrom: "",
  destinationTo: "",
  destinationDate: dayjs(),
  destinationDateTwoWay: dayjs().add(1, "day"),
  showTwoWayDateInput: false,
};

export default function destinationReducer(
  state = initState,
  { type, ...action }
) {
  switch (type) {
    case actions.SET_DESTINATION_FROM:
      return {
        ...state,
        destinationFrom: action.value,
      };

    case actions.SET_DESTINATION_TO:
      return {
        ...state,
        destinationTo: action.value,
      };
    case actions.SET_DESTINATION_DATE:
      return {
        ...state,
        destinationDate: action.value,
      };

    case actions.SET_DESTINATION_DATE_TWO_WAY:
      return {
        ...state,
        destinationDateTwoWay: action.value,
      };

    case actions.SET_SHOW_TWO_WAY_DATE_INPUT:
      return {
        ...state,
        showTwoWayDateInput: action.value,
      };

    default:
      return state;
  }
}
